import type locEn from "./loc.en";

// اللغات والترجمة (specs 28).
const locAr: Record<keyof typeof locEn, string> = {
  "nav.translate": "الترجمة",
  "settings.languages": "اللغات",
  "settings.languages_hint": "لغات واجهة المتجر والأسعار والتواريخ",
  "lang.title": "اللغات",
  "lang.description": "اللغات التي تعرض بها واجهة متجرك. اللغة الأساسية بدون بادئة، والأخرى على ‎/ar/‎ و ‎/fr/‎ وهكذا.",
  "lang.translate": "ترجمة المحتوى",
  "lang.languages": "لغات واجهة المتجر",
  "lang.limit": "{n} من {limit} لغات في خطتك",
  "lang.add": "إضافة لغة",
  "lang.added_toast": "تمت إضافة اللغة. ترجم محتواك ثم انشرها.",
  "lang.add_hint": "تبدأ اللغات الجديدة غير منشورة، حتى لا يرى المتسوقون صفحات مترجمة جزئياً.",
  "lang.language": "اللغة",
  "lang.primary": "أساسية",
  "lang.published": "منشورة",
  "lang.unpublished": "غير منشورة",
  "lang.manage": "إدارة",
  "lang.publish": "نشر",
  "lang.unpublish": "إلغاء النشر",
  "lang.published_toast": "أصبحت {name} متاحة في واجهة متجرك",
  "lang.unpublished_toast": "أُخفيت {name} عن المتسوقين",
  "lang.make_primary": "جعلها أساسية",
  "lang.primary_title": "جعل {name} اللغة الأساسية؟",
  "lang.primary_body": "تُعرض على عنوان متجرك الرئيسي بدون بادئة. تبقى منتجاتك وصفحاتك تُحرّر باللغة التي كتبتها بها، وتملأ الترجمات اللغات الأخرى.",
  "lang.primary_toast": "أصبحت {name} اللغة الأساسية",
  "lang.remove": "إزالة",
  "lang.remove_title": "إزالة {name}؟",
  "lang.remove_body": "ستُحذف ترجماتها أيضاً. لا يمكن التراجع عن ذلك.",
  "lang.removed_toast": "تمت إزالة {name}",
  "lang.limit_reached": "وصلت إلى حد اللغات في خطتك. قم بالترقية لإضافة المزيد.",
  "lang.formats": "التنسيقات",
  "lang.formats_hint": "كيف تظهر الأسعار والأرقام والتواريخ والروابط في كل لغة.",
  "lang.arabic_digits": "الأرقام العربية الهندية",
  "lang.arabic_digits_hint": "عرض ٠١٢٣ بدلاً من 0123 في الصفحات العربية. يقرأ أغلب المتسوقين في الخليج الأرقام اللاتينية بسهولة أكبر.",
  "lang.hijri": "التاريخ الهجري",
  "lang.hijri_hint": "عرض التاريخ الهجري بجانب الميلادي في الصفحات العربية (المقالات والطلبات).",
  "lang.handles": "روابط مترجمة",
  "lang.handles_hint": "استخدام معرّفات مترجمة في الروابط، مثل ‎/ar/products/عباية-سوداء. تبقى الروابط الأصلية تعمل.",
  "lang.money_for": "الأسعار بـ{name}",
  "lang.money_hint": "استخدم {{amount}} للرقم. اتركه فارغاً للتنسيق الافتراضي.",
  "lang.money_label": "تنسيق السعر بـ{name}",
  "lang.money_code_label": "السعر مع رمز العملة بـ{name}",
  "lang.arabic_tip": "يتوقع أغلب المتسوقين في الخليج واجهة متجر بالعربية. أضف العربية للوصول إليهم.",
  "tr.title": "الترجمة",
  "tr.description": "ترجم محتوى متجرك إلى كل لغة. تُعلَّم الترجمات كقديمة عندما يتغيّر النص الأصلي.",
  "tr.import": "استيراد CSV",
  "tr.export": "تصدير CSV",
  "tr.imported": "{n, plural, zero {لم تُستورد أي ترجمة} one {استُوردت ترجمة واحدة} two {استُوردت ترجمتان} few {استُوردت # ترجمات} many {استُوردت # ترجمة} other {استُوردت # ترجمة}}، {skipped, plural, zero {دون تخطّي صفوف} one {وتُخطّي صف واحد} two {وتُخطّي صفان} few {وتُخطّيت # صفوف} many {وتُخطّي # صفاً} other {وتُخطّي # صف}}",
  "tr.language": "اللغة",
  "tr.content": "المحتوى",
  "tr.status": "الحالة",
  "tr.all": "الكل",
  "tr.untranslated": "غير مترجم",
  "tr.outdated": "قديم",
  "tr.search": "بحث",
  "tr.none": "لا يوجد شيء هنا.",
  "tr.pick": "اختر عنصراً من القائمة لترجمته.",
  "tr.n_outdated": "{n, plural, one {ترجمة قديمة} two {ترجمتان قديمتان} few {# ترجمات قديمة} many {# ترجمةً قديمة} other {# ترجمة قديمة}}",
  "tr.editing": "الترجمة إلى {lang}",
  "tr.auto": "ترجمة تلقائية",
  "tr.auto_outdated": "تحديث القديم",
  "tr.auto_done": "تُرجم تلقائياً — يُرجى المراجعة",
  "tr.arabic_review": "قد تُخطئ الترجمة الآلية إلى العربية في الأسلوب واللهجة. راجعها قبل النشر.",
  "tr.nothing": "لا يوجد نص للترجمة هنا.",
  "tr.outdated_badge": "قديم",
  "tr.still_correct": "ما زالت صحيحة",
  "tr.handle_hint": "اتركه فارغاً للإبقاء على الرابط الأصلي",
  "tr.no_languages": "أضف لغة أولاً",
  "tr.no_languages_body": "تحتاج الترجمة إلى لغة ثانية لواجهة المتجر، مثل العربية.",
  "tr.add_language": "إضافة لغة",
  "tr.f.title": "العنوان",
  "tr.f.body": "الوصف",
  "tr.f.seo_title": "عنوان محركات البحث",
  "tr.f.seo_description": "وصف محركات البحث",
  "tr.f.handle": "معرّف الرابط",
  "tr.f.summary": "المقتطف",
  "tr.f.image_alt": "النص البديل للصورة",
  "tr.f.name": "الاسم",
  "tr.f.description": "الوصف",
  "tr.f.label": "التسمية",
  "tr.f.instructions": "التعليمات",
  "tr.f.home_title": "عنوان الصفحة الرئيسية",
  "tr.f.home_description": "وصف الصفحة الرئيسية",
  "tr.f.password_message": "رسالة صفحة كلمة المرور",
  "tr.f.option_name": "اسم الخيار {n}",
  "tr.f.option_value": "قيمة الخيار {n}: {value}",
  "tr.f.menu_item": "عنصر القائمة: {name}",
  "tr.type.product": "المنتجات",
  "tr.type.collection": "المجموعات",
  "tr.type.page": "الصفحات",
  "tr.type.blog": "المدوّنات",
  "tr.type.article": "المقالات",
  "tr.type.menu": "قوائم التنقل",
  "tr.type.policy": "السياسات",
  "tr.type.shop": "بيانات المتجر",
  "tr.type.theme": "محتوى القالب",
  "tr.type.theme_strings": "نصوص القالب",
  "tr.type.shipping_rate": "أسعار الشحن",
  "tr.type.payment_method": "طرق الدفع",
  "tr.type.search_filter": "فلاتر البحث",
};
export default locAr;
